import React from 'react'
import { Link } from 'react-router'
import classNames from 'classnames'

import listingStyles from './styles/listing.scss'
import unitStyles from './styles/unit.scss'

export default class UnitDetailsWopi360AddModalFormRow extends React.PureComponent {
  handleSelect = () => this.props.onSelect(this.props.target.uuid)

  render() {
    const { target, isSelected, isDisabled } = this.props

    return (
      <tr
        key={target.uuid}
        className={classNames({
          [unitStyles.disabledWopi360Row]: isDisabled
        })}
      >
        {isDisabled && <td className={listingStyles.select} style={{ width: 80 }} />}

        {!isDisabled && (
          <td className={listingStyles.select} style={{ width: 80 }} onClick={this.handleSelect}>
            <input type="checkbox" checked={isSelected} />
          </td>
        )}

        <td>
          <div>
            <Link to={`/target/${target.uuid}/details`}>
              {target.givenName} {target.familyName}
            </Link>
          </div>

          <div>
            <small>{target.email}</small>
          </div>

          <div>
            <small>{target.role}</small>
          </div>
        </td>

        <td>{target.organisation}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitDetailsWopi360AddModalFormRow.js